import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    CardMedia,
    Dialog,
    IconButton,
    makeStyles,
} from '@material-ui/core';
import { ChevronLeft, ChevronRight, Close } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
    dialogImageWrapper: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    navButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#fff',
        zIndex: 1,
    },
    leftButton: {
        left: 10,
    },
    rightButton: {
        right: 10,
    },
    closeButton: {
        position: 'absolute',
        top: 10,
        right: 10,
        color: '#fff',
        zIndex: 2,
    },
    dialogImage: {
        maxWidth: '98%',
        maxHeight: '98%',
        objectFit: 'contain',
    },
}));

export default function ImageGallery({ images, columns = 4, height = 220 }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleClickOpen = (index) => {
        setCurrentIndex(index);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const getGridSize = (col) => {
        if (col) return col;
        switch (columns) {
            case 1:
                return 12;
            case 2:
                return 6;
            case 3:
                return 4;
            case 4:
            default:
                return 3;
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!open) return;

            if (event.key === 'ArrowRight') {
                handleNext();
            } else if (event.key === 'ArrowLeft') {
                handlePrev();
            } else if (event.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open, images.length]);

    return (
        <>
            <Grid container spacing={2}>
                {images.map((img, index) => (
                    <Grid item xs={12} sm={getGridSize(img.col ?? null)} key={index}>
                        <Card style={{backgroundColor: "transparent"}}>
                            <CardMedia
                                component="img"
                                image={typeof img === "string" ? img : img.img}
                                title={`Image ${index + 1}`}
                                style={{ width: "unset", maxWidth: "100%", maxHeight: images.length === 1 ? 360 : height, cursor: 'pointer' }}
                                onClick={() => handleClickOpen(index)}
                            />
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Dialog open={open} onClose={handleClose} fullScreen>
                <div className={classes.dialogImageWrapper}>
                    {images.length > 1 && (
                        <>
                            <IconButton
                                className={`${classes.navButton} ${classes.leftButton}`}
                                onClick={handlePrev}
                            >
                                <ChevronLeft fontSize="large" />
                            </IconButton>

                            <IconButton
                                className={`${classes.navButton} ${classes.rightButton}`}
                                onClick={handleNext}
                            >
                                <ChevronRight fontSize="large" />
                            </IconButton>
                        </>
                    )}

                    <IconButton className={classes.closeButton} onClick={handleClose}>
                        <Close fontSize="large" />
                    </IconButton>

                    <img
                        src={typeof images[currentIndex] === "string" ? images[currentIndex] : images[currentIndex].img}
                        alt={`Preview ${currentIndex + 1}`}
                        className={classes.dialogImage}
                    />
                </div>
            </Dialog>
        </>
    );
}
